import { commonClient } from "@/utils/http";
import { from } from "rxjs";

export function  getLeadInfo(id: string) {
    return from(commonClient.get(`/chat/push/info?id=${id}`,));
}
